export const QUERY_KEYS = {
  JOB: {
    list: 'jobs',
    detail: 'job',
    available: 'availableJob',
  },
  ASSIGNMENT: {
    list: 'assignments',
    detail: 'assignment',
    available: 'availableAssignment',
    meta: 'assignmentMeta',
    requests: 'assignmentRequests',
    missingChecklist: 'missingAssignmentChecklist',
  },
};
